import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import Line3Svg from '@/assets/Line3.svg';

const Line3 = ({ size, variant, className }: IconProps) => (
  <img
    src={Line3Svg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default Line3;
